import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'

export default function useQcRejectList() {
  const refQcRejectListTable = ref(null)

  const tableColumns = [
    { key: 'item_code', sortable: true, label: 'Item Code' },
    { key: 'product_name', sortable: true, label: 'Nama Produk' },
    { key: 'qty_reject', sortable: true, label: 'Qty Reject' },
    { key: 'sale_price', sortable: true, label: 'Harga Sale' },
    { key: 'reason', sortable: true, label: 'Alasan Reject' },
    { key: 'note', sortable: false, label: 'Catatan' },
    { key: 'reported_at', sortable: true, label: 'Tanggal Reject' },
    { key: 'images_count', sortable: false, label: 'Foto' },
    { key: 'actions', label: 'Aksi' },
  ]

  const perPage = ref(15)
  const totalItems = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('reported_at')
  const isSortDirDesc = ref(true)

  const dataMeta = computed(() => {
    const localItemsCount = refQcRejectListTable.value ? refQcRejectListTable.value.localItems.length : 0

    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalItems.value,
    }
  })

  const refetchData = () => {
    if (refQcRejectListTable.value) {
      refQcRejectListTable.value.refresh()
    }
  }

  watch([currentPage, perPage, searchQuery, sortBy, isSortDirDesc], () => {
    refetchData()
  })

  const fetchQcRejects = (ctx, callback) => {
    store
      .dispatch('app-qc-reject/fetchQcRejects', {
        q: searchQuery.value,
        per_page: perPage.value,
        page: currentPage.value,
        sort_by: sortBy.value,
        direction: isSortDirDesc.value ? 'desc' : 'asc',
      })
      .then(response => {
        callback(response.data.data)
        totalItems.value = response.data.pagination.total
      })
      .catch(() => {
        callback([])
        totalItems.value = 0
      })
  }

  return {
    fetchQcRejects,
    tableColumns,
    perPage,
    currentPage,
    totalItems,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refQcRejectListTable,
    refetchData,
  }
}
